import React from 'react';
import { RocketIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#050505] py-10 md:py-14 pb-24 md:pb-14 border-t border-white/5" data-id="element-86">
      <div className="container mx-auto px-4 text-center" data-id="element-87">
        <div className="flex justify-center mb-4" data-id="element-88">
          <div className="flex items-center gap-2 text-lg md:text-2xl font-display text-white uppercase tracking-widest" data-id="element-89">
            <RocketIcon className="text-gold-500" size={22} data-id="element-90" />
            Motor de Riqueza™
          </div>
        </div>

        <div className="text-gold-500 font-bold tracking-widest uppercase mb-3 text-xs md:text-sm" data-id="element-91">
          Wealth Engine — @wealthengine.ar
        </div>

        <p className="text-gray-400 text-sm max-w-md mx-auto mb-6 leading-relaxed" data-id="element-92">
          El kit de negocio digital N°1 para emprendedores en Argentina. Porque
          arrancar no debería costarte meses de confusión.
        </p>

        <div className="space-y-1 text-xs text-gray-500 mb-8" data-id="element-93">
          <p data-id="element-94">Creado por @nicoquarone</p>
          <p data-id="element-95">Academia @wealthengine.ar</p>
          <p className="text-gold-500/80 hover:text-gold-500 transition-colors cursor-pointer" data-id="element-96">
            wealthenginearg.com
          </p>
        </div>

        <div className="text-[10px] text-gray-600 uppercase tracking-widest" data-id="element-97">
          © Wealth Engine™ 2025. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}